import Image from 'next/image';
import { useContext } from 'react';

import { MediaQuery, useMediaQuery } from '../../../hooks/useMediaQuery';
import { AppContext } from '../../../context/App/context';
import { DispatchEvents } from '../../../enums/dispatchEvent';
import { ShowroomDetailsType } from '../../../types/showroom';

export function ShowroomLocation(props: ShowroomDetailsType) {
  const {
    buildingAddress = '',
    calendlyUrl,
    cityAddress,
    contactNumber,
    email,
    hasShowroomViewing,
    openHours,
    showroomImage,
    showroomViewingLink,
    showroomLocation
  } = props;

  const { dispatch } = useContext(AppContext);

  function handleOpenBookAppointmentLink() {
    dispatch({
      type: DispatchEvents.DISPLAY_CALENDLY,
      payload: {
        isOpen: true,
        url: calendlyUrl
      }
    });
  }

  function handleOpenShowroomViewingLink() {
    if (window) window.open(showroomViewingLink);
  }

  const isDesktop = useMediaQuery(MediaQuery.LG);

  const showroomViewingButton = hasShowroomViewing ? (
    <li>
      <button
        className="text-left hover:text-primaryBlue font-MuseoSans300 font-bold"
        onClick={handleOpenShowroomViewingLink}
      >
        Click here to virtually tour our showroom
      </button>
    </li>
  ) : (
    ''
  );

  const contactNumbers = contactNumber.map((number, index) => {
    const divider = index !== contactNumber.length - 1 ? '/' : '';

    return (
      <>
        <a className="hover:text-primaryBlue mx-1" href={number.link}>
          {number.value}
        </a>
        {divider}
      </>
    );
  });

  const imageHeight = isDesktop ? 500 : 300;
  const imageWidth = isDesktop ? 700 : 450;

  return (
    <>
      <div className="w-full bg-headerBackground">
        <div className="w-full max-w-defaultMax flex flex-col lg:flex-row justify-center items-center m-auto my-4 py-8 px-5">
          <Image
            alt="showroom-image"
            blurDataURL="/icons/blur-placeholder.png"
            height={imageHeight}
            placeholder="blur"
            src={showroomImage}
            width={imageWidth}
          />
          <div
            className={`w-full lg:w-5/12 lg:ml-10 mt-10 lg:mt- flex flex-col lg:items-start font-MuseoSans100`}
            style={{ maxWidth: `${imageWidth}px` }}
          >
            <h5 className="text-header5">{showroomLocation}</h5>
            <ul className="text-subtitle font-extralight mt-3">
              <li>{buildingAddress}</li>
              <li>{cityAddress}</li>
              <li>Tel: {contactNumbers}</li>
              <li>
                Email:{' '}
                <a
                  className="hover:text-primaryBlue"
                  href="mailto:subzero@focusglobalinc.com"
                >
                  {email}
                </a>
              </li>
              <li>Open {openHours}</li>
              <li>
                <button
                  className="text-left mt-4 hover:text-primaryBlue font-MuseoSans300 font-bold"
                  onClick={handleOpenBookAppointmentLink}
                >
                  Click here to book an online or showroom appointment
                </button>
              </li>
              {showroomViewingButton}
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}

export default ShowroomLocation;
